export function parseHourInput(text) {
  const value = String(text).trim();
  if (!value) return 0;
  const clock = value.match(/^(\d{1,2})[:h](\d{1,2})$/i);
  let hours;
  if (clock) {
    if (Number(clock[2]) >= 60) return null;
    hours = Number(clock[1]) + Number(clock[2]) / 60;
  } else {
    if (!/^\d{1,2}(?:[.,]\d{1,4})?$/.test(value)) return null;
    hours = Number(value.replace(',', '.'));
  }
  return hours >= 0 && hours <= 24 ? hours : null;
}
export function formatHourInput(value, format) {
  if (value == null || value === '') return '';
  const hours = Number(value);
  if (!Number.isFinite(hours)) return '';
  if (format === 'centiemes') return hours.toFixed(2).replace('.', ',');
  const minutes = Math.round(hours * 60);
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}
